export enum WorkflowStepFunctionCreateOrEditFieldName {
  Name = 'name',
  Type = 'type',
  SubscribedEvents = 'subscribedEvents',
  PublishedEvents = 'publishedEvents',
  Code = 'code'
}
